module.exports = __webpack_public_path__ + "img/read-more-icon.874148ee.svg";